import { createApiRequester } from './request'

export const useAuthApi = createApiRequester('auth')
